import { createSvgIcon } from "@mui/material";

export const DrawPathIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 24" fill="currentColor">
        <polygon points="8.4 20.2 9.1 20.6 16.8 14 16.9 10.1 10.9 6.7 7.7 8.9 6.2 18.9 6.9 19.2 11.5 11 13 11.8 8.4 20.2" />
        <rect x="13.5" y="2.7" width="3.4" height="6.9" transform="translate(2.5 16.4) rotate(-60.9)" />
        <path d="M1.5,12.6" />
    </svg>,
    "DrawPath"
);
